<template>
	<div>
		<div v-if="activeTab === 'welcome'">
			<div class="container">
				<div class="logoBox" style="margin-top: 10vh;">
					<div  style="padding: 12px;">
						
						<img style="width: 80vw;height: 80vw;" src="images/logo_atm.png"/>
					</div>
				</div>

				<div style="width: 100%;text-align: center;margin-top: 8vh;" id="addAGE_btn_container">
					<button class="btn" @click="btnClick();"
						style="width: 50%;font-size: 25px;" data-lang="t_1"></button>
				</div>
				<div style="text-align: center;">
					<div  style="padding: 12px;" @click="CopyURL('https://btlatm.com/')">
						<label data-lang="t_410">高速访问网址：</label>https://btlatm.com/
					</div>
					<div  style="padding: 12px;" @click="CopyURL('https://btlatm.com/')">
						<label data-lang="t_410">备用高速访问网址：</label>https://atmbtl.com/
					</div>
					<div  style="padding: 12px;word-break: break-word;" @click="CopyURL('https://ipfs.io/ipfs/bafybeigsxa2pgpfmepjbsxw43wytgdck4vfifr5musvdkbaouvvgcdzdym/')">
						<label data-lang="t_411">永久访问IPFS网址：</label><br>
						https://ipfs.io/ipfs/bafybeigsxa2pgpfmepjbsxw43wytgdck4vfifr5musvdkbaouvvgcdzdym/
					</div>
				</div>
				
				<!--
				<div class="banner">
					<div >{{currentTime}}</div>
					<input v-model="addDayValue" />
					<button class="btn btn-primary" @click="AddDayClick()">增加一天</button>
				</div>-->
			</div>
		</div>
		<Yszc v-else-if="activeTab == 'yszc'" @data-received="processData" />
		<About v-else-if="activeTab == 'about'" @data-received="processData"/>
		<Service  v-else-if="activeTab == 'service'" @data-received="processData"/>
		<Terms  v-else-if="activeTab == 'terms'" @data-received="processData"/>
		<TEAM v-else-if="activeTab == 'team'" @data-received="processData"/>
		
		<div v-else id="app">
			<div class="topbar">
				<div class="topbar-inner">
					<div class="brand">
						<img src = "images/logo_atm.png" style="width: 24px;height: 24px;"/>
						<!--<span class="brand-dot"></span>-->
						<span>{{ currentTitle }}</span>
					</div>
					<div>
						<div class="language-selector" :class="{active:showLanguageDownList == true}">
						    <div class="language-selected"  @click.stop="showLanguageDownList = true">
						        <img :src="langSelectedImg"  class="flag-img">
						        <span class="language-name">{{langSelectedText}}</span>
						        <span class="dropdown-arrow">▼</span>
						    </div>
						    <div class="language-dropdown" >
						        
						        <div class="language-option" @click="LanguageSelected('en','https://flagcdn.com/w20/us.png','English')">
						            <img src="https://flagcdn.com/w20/us.png" alt="English" class="flag-img">
						            <span class="language-name">English</span>
						        </div>
						        <div class="language-option" @click="LanguageSelected('de','https://flagcdn.com/w20/de.png','Deutsch')">
						            <img src="https://flagcdn.com/w20/de.png" alt="Deutsch" class="flag-img">
						            <span class="language-name">Deutsch</span>
						        </div>
						        <div class="language-option" @click="LanguageSelected('fr','https://flagcdn.com/w20/fr.png','Fran')">
						            <img src="https://flagcdn.com/w20/fr.png" alt="Français" class="flag-img">
						            <span class="language-name">Français</span>
						        </div>
						        <div class="language-option" @click="LanguageSelected('ja','https://flagcdn.com/w20/jp.png','日本語')">
						            <img src="https://flagcdn.com/w20/jp.png" alt="日本語" class="flag-img">
						            <span class="language-name">日本語</span>
						        </div>
						        <div class="language-option" @click="LanguageSelected('ko','https://flagcdn.com/w20/kr.png','한국어')">
						            <img src="https://flagcdn.com/w20/kr.png" alt="한국어" class="flag-img">
						            <span class="language-name">한국어</span>
						        </div>
						        <div class="language-option" @click="LanguageSelected('ru','https://flagcdn.com/w20/ru.png','Русский')">
						            <img src="https://flagcdn.com/w20/ru.png" alt="Русский" class="flag-img">
						            <span class="language-name">Русский</span>
						        </div>
								<div class="language-option" @click="LanguageSelected('zh','https://flagcdn.com/w20/cn.png','简体中文')">
								    <img src="https://flagcdn.com/w20/cn.png" class="flag-img">
								    <span class="language-name">简体中文</span>
								</div>
								<div class="language-option" @click="LanguageSelected('tw','https://flagcdn.com/w20/tw.png','繁體中文')">
								    <img src="https://flagcdn.com/w20/tw.png" alt="繁體中文" class="flag-img">
								    <span class="language-name">繁體中文</span>
								</div>
						    </div>
						</div>
					</div>
					<!--<button class="btn btn-primary">{{HomeAccount}}</button>-->
				</div>
			</div>
			
			<main class="main-content">

				<Home v-if="activeTab === 'home'" />
				<Node v-else-if="activeTab === 'node'" />
				<Transaction v-else-if="activeTab === 'transaction'" />
				<Profile v-else-if="activeTab === 'profile'" @data-received="processData"/>
				<DEOPSIT v-else-if="activeTab == 'deopsit'" @data-received="processData"/>
			</main>
			<div v-if="showTabBar == true" class="tab-bar">
				<div class="tab-item" :class="{ active: activeTab === 'home' }" @click="switchTab('home')">
					<i class="fas fa-home"></i>
					<span data-lang="t_2"></span>
				</div>
				<div class="tab-item" :class="{ active: activeTab === 'node' }" @click="switchTab('node')">
					<i class="fas fa-sitemap"></i>
					<span data-lang="t_3"></span>
				</div>
				<div  class="tab-item" :class="{ active: activeTab === 'transaction' }"
					@click="switchTab('transaction')">
					<i class="fas fa-exchange-alt"></i>
					<span data-lang="t_4"></span>
				</div>
				<div class="tab-item" :class="{ active: activeTab === 'profile' }" 
						@click="switchTab('profile')">
					<i class="fas fa-user"></i>
					<span data-lang="t_5"></span>
				</div>
				
				<div class="tab-item" :class="{ active: activeTab === 'deopsit' }"
						@click="switchTab('deopsit')">
					<i class="fas fa-user"></i>
					<span>比特龙</span>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	import Home from './components/Home.vue'
	import Node from './components/Node.vue'
	import Transaction from './components/Transaction.vue'
	import Profile from './components/Profile.vue'
	import DEOPSIT from './components/Deopsit.vue';//比特龙存取款
	import Yszc from './components/child/yszc.vue';//隐私政策
	import About from './components/child/about.vue';//关于ATM
	import Service from './components/child/service.vue';//客服中心
	import Terms from './components/child/terms.vue';//用户协议
	import TEAM from './components/child/team.vue';//我的团队
	
	export default {
		name: 'App',
		components: {
			Home,
			Node,
			Transaction,
			Profile,
			Yszc,
			About,
			Service,
			Terms,
			TEAM,
			DEOPSIT
		},
		data() {
			return {
				activeTab: 'welcome',
				showTabBar: true,
				HomeAccount: "",
				inputValue:"1",//绑定输入值
				
				showLanguageDownList:false,
				langSelectedImg:"https://flagcdn.com/w20/tw.png",
				langSelectedText:"繁體中文",
				currentTitle:Lang[lg].t_2,
				currentTime:0,
				addDayValue:0,
			}
		},
		
		mounted() {
			this.LanguageBoxInit();
			this.setLanguage();
			var that = this;
			setInterval(function() {
				if(that.HomeAccount != shortAccount){
					that.activeTab = "welcome";
					that.HomeAccount = shortAccount
				}
			}, 1000);
			// 点击页面其他地方关闭下拉菜单
			document.addEventListener('click',function() {
			    that.showLanguageDownList = false;
				
			});
			setTimeout(async function(){
				try{
					let t = await conHis.getTime().call();
					console.log(t)
					that.currentTime = new Date(t * 1000).toLocaleString();
				}catch(e){
					console.log(e)
				}
			},1000);
		},

		methods: {
			setLanguage(){
				const elements = document.querySelectorAll('[data-lang]');
				
				elements.forEach(element => {
				    const langValue = element.getAttribute('data-lang');
					
				    element.innerHTML = Lang[lg][langValue];
				});
			},
			async AddDayClick(){
				
				try {
					if (await gasIsEnough() == false) return;
					MsgBox.waitTX("增加"+this.addDayValue+"天数", "增加"+this.addDayValue+"天数");
					let par = {
						from: Account,
						to: addrBonus,
						gasPrice: await web3.eth.getGasPrice(),
						nonce: await web3.eth.getTransactionCount(Account)
					};
				
					const gas = await conHis.setTime(this.addDayValue).estimateGas(par);
					par.gas = gas;
					const success = await conHis.setTime(this.addDayValue).send(par);
					MsgBox.open("增加"+this.addDayValue+"天数", "增加"+this.addDayValue+"天数成功");
				
				} catch (e) {
					MsgBox.open("增加"+this.addDayValue+"失败", e.message)
				}
				
			},
			processData(data){
				this.activeTab = data.message
				this.setCurrentTitle();
			},
			switchTab(tab) {
				this.activeTab = tab
				this.setCurrentTitle();
			},
			async getNewID(){//生成一个随机id，并检测是否已被占用
				let newID = 0;
				let Index = 0;
				const min = 0x100000;
				const max = 0xFFFFFF;
				while(1){
					Index ++ ;
					newID = Math.floor(Math.random() * (max - min + 1)) + min;
					await Sleep(500);
					if(await conMine.getFindAddressFromId(newID).call() == addrNull)return newID;
					Toast.open(Lang[lg]['t_6'] + Index + Lang[lg]['t_7']);
					if(Index % 10 == 0){//如果5秒钟还没有生成合适的id，提示一下
						let result = await MsgBox.open(Lang[lg]['t_8'],Lang[lg]['t_9']);
						if(result == false)return 0;
					}
				}
			},
			async btnClick() {
				
				this.HomeAccount = shortAccount;
				//const node = await conMine.getPeopleTree(Account).call();
				const node = await conExc.getUser(Account).call();
				await Sleep(this.$waitTime);
				
				if (node.Type == 0) { 
					const url = window.location.toString();
					let code="";
					let len = url.indexOf("ref=");
					let len2 =url.indexOf("&");
					if(len != -1){
						if(len2 == -1)len2 = url.length;
						code = url.substring(len + 4, len2);
					}
					
					
					//提示推荐码
					//调对话诞框
					const Warning_dialog = document.getElementById("modal-msgbox");
					const Warning_cancel = document.getElementById("msgbox-cancel");
					const Warning_close = document.getElementById("msgbox-close");
					const Warning_confirm = document.getElementById("msgbox-ok");
					const Warning_Info = document.getElementById("msgbox-caption");					
					Warning_dialog.classList.add("show");					
					Warning_Info.innerHTML = `
						<div class="k" style="text-align: left;">${Lang[lg]['t_10']}</div>
						<div class="row">
							
							<input id="checkRefCode" value ="${code}"/>
						</div>
					`;
					code  = await new Promise((resolve) => {
							// 事件监听
							Warning_cancel.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(false);
							};
							Warning_close.onclick = () => {
								Warning_dialog.classList.remove("show");
								resolve(false);
							};
							Warning_confirm.onclick = () => {
								Warning_dialog.classList.remove("show");
								let count = document.getElementById("checkRefCode").value;
								resolve(count);
							};
						});
					if(code == false)return;
					let NewID = await this.getNewID();
					if(NewID == 0){
						MsgBox.open(Lang[lg]['t_8'],Lang[lg]['t_11']);
						return;
					}
					code = Number("0x" + code);
					try {
						if(await gasIsEnough() == false)return;
						MsgBox.waitTX(Lang[lg]['t_12'], Lang[lg]['t_12']);
						let par = {
							from: Account,
							to: addrMine,
							gasPrice: await web3.eth.getGasPrice(),
							nonce: await web3.eth.getTransactionCount(Account)
						};
						const gas = await conMine.addNode(code,NewID).estimateGas(par);
						
						par.gas = gas;
						await conMine.addNode(code,NewID).send(par);
						MsgBox.open(Lang[lg]['t_12'],Lang[lg]['t_14'])
						this.activeTab = "home";
						this.setCurrentTitle();
						this.showTabBar = true;
						
						this.setLanguage();
					} catch (e) {
						if (e.message.indexOf("User denied") > 0) {
							MsgBox.open(Lang[lg]['t_12'],Lang[lg]['t_15']);
						} else
							MsgBox.open(Lang[lg]['t_13'], e);
					}
				} else{
					//申请签名
					const message = 'Welcome to ATM';
					const signature = await window.ethereum.request({
					  method: 'personal_sign',
					  params: [message,Account]
					});
					//验签
					const recoveredAddress = web3.eth.accounts.recover(message, signature);
					const isValid = (recoveredAddress.toLowerCase() === Account.toLowerCase());
					
					if(isValid == false){
						MsgBox.open(Lang[lg].t_8,"Verification failed");
						return;
					}
					if (node.Type == 1 || node.Type == 3 || node.Type == 11) { //已经加入了，显示
						this.activeTab = "home";
						this.setCurrentTitle();
						this.showTabBar = true;
					} else if (node.Type == 2 || node.Type == 4 || node.Type == 12) { //做市商，只显示交易页
						this.activeTab = "transaction";
						this.setCurrentTitle();
						this.showTabBar = false;
					}
					this.setLanguage();
				}
			},
			LanguageSelected(language,img,text){
				this.langSelectedImg = img;
				this.langSelectedText = text;
				this.showLanguageDownList = false;
				lg = language;
				localStorage.setItem("ageLanguage",language);
				this.activeTab = 'welcome';
				var that = this;
				setTimeout(function(){
					that.setLanguage();
				},200);
				//this.setCurrentTitle();
			},
			LanguageBoxInit(){
				if(lg == "en"){this.langSelectedImg = "https://flagcdn.com/w20/us.png";this.langSelectedText = "English";}
				if(lg == "de"){this.langSelectedImg = "https://flagcdn.com/w20/de.png";this.langSelectedText = "Deutsch";}
				if(lg == "fr"){this.langSelectedImg = "https://flagcdn.com/w20/fr.png";this.langSelectedText = "Fran";}
				if(lg == "ja"){this.langSelectedImg = "https://flagcdn.com/w20/jp.png";this.langSelectedText = "日本語";}
				if(lg == "ko"){this.langSelectedImg = "https://flagcdn.com/w20/kr.png";this.langSelectedText = "한국어";}
				if(lg == "ru"){this.langSelectedImg = "https://flagcdn.com/w20/ru.png";this.langSelectedText = "Русский";}
				if(lg == "zh"){this.langSelectedImg = "https://flagcdn.com/w20/cn.png";this.langSelectedText = "简体中文";}
				if(lg == "tw"){this.langSelectedImg = "https://flagcdn.com/w20/tw.png";this.langSelectedText = "繁體中文";}
				
			},
			setCurrentTitle(){
				const titles = {
					home: Lang[lg]['t_2'],
					node: Lang[lg]['t_3'],
					transaction: Lang[lg]['t_4'],
					profile: Lang[lg]['t_5']
				}
				this.currentTitle=titles[this.activeTab];
			},
			CopyURL(url){
				copyRefURL(url);
			},
		}
	}
</script>

<style scoped>
	/* 视频边框光影效果 */
	.video-border {
	    padding: 8px;
	    border-radius: 20px;
	    background: linear-gradient(45deg, var(--primary), var(--secondary), var(--accent));
	    position: relative;
	    box-shadow: 0 0 30px rgba(0, 198, 255, 0.5);
	}
	
	.video-border::before {
	    content: '';
	    position: absolute;
	    top: 1px;
	    left: 1px;
	    right: 1px;
	    bottom: 1px;
	    background: var(--dark);
	    border-radius: 15px;
	    z-index: 1;
	}
	
	.video-border video {
	    position: relative;
	    z-index: 2;
	    width: 100%;
	    height: auto;
	    display: block;
	    border-radius: 12px;
	    object-fit: contain;
	    background-color: #000;
	}
	
	.video-label {
	    position: absolute;
	    bottom: 0;
	    left: 0;
	    right: 0;
	    background: linear-gradient(transparent, rgba(0, 0, 0, 0.9));
	    color: white;
	    padding: 20px;
	    font-weight: 600;
	    z-index: 3;
	    border-bottom-left-radius: 12px;
	    border-bottom-right-radius: 12px;
	}
	
	.horizontal-video {
	    max-width: 1000px;
	    margin: 0 auto;
	}
	
	.vertical-video {
	    max-width: 400px;
	    margin: 0 auto;
	}
	/* 语言选择器容器 */
	.language-selector {
	    display: inline-block;
	    position: relative;
	    font-family: system-ui, -apple-system, sans-serif;
	}
	
	/* 当前选择项 */
	.language-selected {
	    display: flex;
	    align-items: center;
	    gap: 8px;
	    padding: 8px 12px;
	    background-color: rgba(255, 255, 255, 0.05);
	    border: 1px solid rgba(255, 255, 255, 0.15);
	    border-radius: 6px;
	    cursor: pointer;
	    transition: all 0.2s ease;
	    color: #f0f0f0;
	    white-space: nowrap;
	}
	
	.language-selected:hover {
	    background-color: rgba(255, 255, 255, 0.1);
	    border-color: rgba(255, 255, 255, 0.25);
	}
	
	.language-selector.active .language-selected {
	    border-bottom-left-radius: 0;
	    border-bottom-right-radius: 0;
	    border-color: rgba(255, 255, 255, 0.3);
	    background-color: rgba(255, 255, 255, 0.1);
	}
	
	/* 国旗图片样式 */
	.flag-img {
	    width: 20px;
	    height: 15px;
	    object-fit: cover;
	    border-radius: 2px;
	    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
	}
	
	/* 语言名称 */
	.language-name {
	    font-size: 14px;
	    font-weight: 500;
	}
	
	/* 下拉箭头 */
	.dropdown-arrow {
	    margin-left: 6px;
	    font-size: 10px;
	    color: rgba(255, 255, 255, 0.6);
	    transition: transform 0.2s ease;
	}
	
	.language-selector.active .dropdown-arrow {
	    transform: rotate(180deg);
	    color: rgba(255, 255, 255, 0.9);
	}
	
	/* 下拉菜单 */
	.language-dropdown {
	    position: absolute;
	    top: 100%;
	    left: 0;
	    width: 100%;
	    background-color: #1a1a1a;
	    border: 1px solid rgba(255, 255, 255, 0.15);
	    border-top: none;
	    border-bottom-left-radius: 6px;
	    border-bottom-right-radius: 6px;
	    overflow: hidden;
	    z-index: 100;
	    display: none;
	    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
	    min-width: 100%;
	}
	
	.language-selector.active .language-dropdown {
	    display: block;
	    animation: fadeIn 0.2s ease-out;
	}
	
	/* 语言选项 */
	.language-option {
	    display: flex;
	    align-items: center;
	    gap: 8px;
	    padding: 8px 12px;
	    cursor: pointer;
	    transition: background-color 0.15s ease;
	    color: #e0e0e0;
	    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
	    white-space: nowrap;
	}
	
	.language-option:last-child {
	    border-bottom: none;
	}
	
	.language-option:hover {
	    background-color: rgba(255, 255, 255, 0.08);
	}
	
	.language-option.selected {
	    background-color: rgba(59, 130, 246, 0.15);
	    color: #ffffff;
	}
	
	/* 动画 */
	@keyframes fadeIn {
	    from {
	        opacity: 0;
	        transform: translateY(-8px);
	    }
	    to {
	        opacity: 1;
	        transform: translateY(0);
	    }
	}
	
	/* 响应式调整 */
	@media (max-width: 480px) {
	    .flag-img {
	        width: 18px;
	        height: 13px;
	    }
	    
	    .language-name {
	        font-size: 13px;
	    }
	    
	    .language-selected, .language-option {
	        padding: 6px 10px;
	    }
	}
</style>